import ChangePasswordIcon from "../assets/icons/changePasswordIcon.tsx";
import LogoutIcons from "../assets/icons/logoutIcons.tsx";
import ProfileIcon from "../assets/icons/profileIcon.tsx";
import TicketsIcon from "../assets/icons/ticketsIcon.tsx";
import UserIcon from "../assets/icons/userIcon.tsx";

interface MenuItem {
  path: string;
  label: string;
  icon: React.FC;
}

export const menuItems: MenuItem[] = [
  {
    path: "/",
    label: "Tickets",
    icon: TicketsIcon,
  },
  {
    path: "/users",
    label: "User Management",
    icon: UserIcon,
  },
  {
    path: "/profile",
    label: "My Profile",
    icon: ProfileIcon,
  },
  {
    path: "/changePassword",
    label: "Change Password",
    icon: ChangePasswordIcon,
  },
  {
    path: "/logout",
    label: "Log Out",
    icon: LogoutIcons,
  },
];
